// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"2564":"css/admin-app.7010","7666":"css/app.7010"}[chunkId] + ".css";
};